import { EventEmitter, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject } from 'rxjs';

import { AvailableLocales, availableLocales } from '../entities/config';
import { getSources } from '../utils';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    public isTranslationReady$ = new BehaviorSubject<boolean>(false);

    constructor(private readonly translocoService: TranslocoService) {}

    public async setTranslations(scopes: string[]): Promise<void> {
        const lang = this.translocoService.getActiveLang();
        const missingScopes: string[] = [];

        // Проверяем наличие загруженного перевода для каждого скоупа и составляем список недостающих переводов
        scopes.forEach((scope) => {
            const translation = this.translocoService.getTranslation(`${scope}/${lang}`);

            if (Object.keys(translation).length === 0) {
                missingScopes.push(scope);
            }
        });

        // Загружаем ресурсы только для недостающих переводов
        const sources = await getSources(missingScopes);
        sources.forEach((source) => {
            this.translocoService.setTranslation(source.translation, `${source.name}/${source.locale}`, {
                merge: true
            });
        });
        this.isTranslationReady$.next(true);
    }
}
